/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Support_TeamInputs */

const en_settings_tickets_support_team = /** @type {(inputs: Settings_Tickets_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Team`)
};

/**
* | output |
* | --- |
* | "Support Team" |
*
* @param {Settings_Tickets_Support_TeamInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_support_team = /** @type {((inputs?: Settings_Tickets_Support_TeamInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Support_TeamInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_support_team(inputs)
});
export { settings_tickets_support_team as "settings.tickets.support_team" }